import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { ArrowLeft, LogOut } from 'lucide-react';
import { Button } from '../components/ui/button';
import ClientMasterSheet from '../components/ClientMasterSheet';
import SidebarLayout from '../components/SidebarLayout';

import API from '../utils/api';

export default function MasterSheetPage() {
  const { clientId } = useParams();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClient = async () => {
      try {
        const res = await axios.get(`${API}/clients`, { withCredentials: true, params: { search: clientId } });
        const found = res.data.find(c => c.client_id === clientId);
        setClient(found || null);
      } catch (err) { console.error(err); }
      finally { setLoading(false); }
    };
    fetchClient();
  }, [clientId]);

  const handleLogout = async () => { await logout(); navigate('/login'); };

  if (loading) {
    return (<SidebarLayout title="Master Sheet" subtitle="Client Master Sheet"><div className="flex items-center justify-center py-20"><div className="text-white text-lg">Loading...</div></div></SidebarLayout>);
  }

  if (!client) {
    return (
      <div className="min-h-screen bg-[#05050A] flex items-center justify-center">
        <div className="text-center">
          <p className="text-white text-lg mb-4">Client not found</p>
          <Button onClick={() => navigate('/clients')} className="bg-indigo-600 hover:bg-indigo-700">Back to Clients</Button>
        </div>
      </div>
    );
  }

  const isAdmin = user?.role === 'admin';
  const canWrite = isAdmin || user?.effective_permissions?.clients === 'edit';

  return (
    <SidebarLayout title="Master Sheet" subtitle="Client Master Sheet">
        <ClientMasterSheet clientId={clientId} canWrite={canWrite} />
    </SidebarLayout>
  );
}
